import { formatDate } from '../admin/format';

export const AUDIENCE_LABELS = { council: 'Council only', owners: 'Owners', residents: 'All residents' };

export const keepUntilLabel = (doc) => {
  if (doc.notRecord) return 'Not a record';
  return doc.keepUntil ? `Keep until ${formatDate(doc.keepUntil)}` : 'Keep permanently';
};

export const TEXT_STATUS_LABELS = { readable: 'Readable', found: 'Text found', none: 'Scanned, no text', not_pdf: 'Not a PDF' };

// Downloads through the API (it needs the auth header), then hands the file to the browser.
export async function downloadFile(request, name) {
  const response = await request();
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.click();
  URL.revokeObjectURL(url);
}
